import { NipWorkerEditImprovedComponent } from './nip-worker/nip-worker-edit-improved/nip-worker-edit-improved.component';
import { NipWorkerAllImprovedComponent } from './nip-worker/nip-worker-all-improved/nip-worker-all-improved.component';
import { NipEditImprovedComponent } from './nip/nip-edit-improved/nip-edit-improved.component';
import { PeriodicReportComponent } from './periodic-report/periodic-report.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmployeeResponsibilitiesComponent } from './employee-responsibilities/employee-responsibilities.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { LoginComponent } from './login/login.component';
import { MachinsAddComponent } from './machines/machins-add/machins-add.component';
import { MachinsAllComponent } from './machines/machins-all/machins-all.component';
import { MachinsEditComponent } from './machines/machins-edit/machins-edit.component';
import { NipWorkerEditComponent } from './nip-worker/nip-worker-edit/nip-worker-edit.component';
import { NipWorkerComponent } from './nip-worker/nip-worker.component';
import { NipAddComponent } from './nip/nip-add/nip-add.component';
import { NipEditComponent } from './nip/nip-edit/nip-edit.component';
import { NipComponent } from './nip/nip.component';
import { OperationsAddComponent } from './operations/operations-add/operations-add.component';
import { OperationsEditComponent } from './operations/operations-edit/operations-edit.component';
import { OperationsComponent } from './operations/operations.component';
import { PackageTypesAddComponent } from './package-types/package-types-add/package-types-add.component';
import { PackageTypesEditComponent } from './package-types/package-types-edit/package-types-edit.component';
import { PackageTypesComponent } from './package-types/package-types.component';
import { PartnersAddComponent } from './partners/partners-add/partners-add.component';
import { PartnersEditComponent } from './partners/partners-edit/partners-edit.component';
import { PartnersComponent } from './partners/partners.component';
import { ProductTypesAddComponent } from './product-types/product-types-add/product-types-add.component';
import { ProductTypesEditComponent } from './product-types/product-types-edit/product-types-edit.component';
import { ProductTypesComponent } from './product-types/product-types.component';
import { ProductsAddComponent } from './products/products-add/products-add.component';
import { ProductsCopyComponent } from './products/products-copy/products-copy.component';
import { ProductsEditComponent } from './products/products-edit/products-edit.component';
import { ProductsComponent } from './products/products.component';
import { StatusAddComponent } from './status/status-add/status-add.component';
import { StatusEditComponent } from './status/status-edit/status-edit.component';
import { StatusComponent } from './status/status.component';
import { UsersAddComponent } from './users/users-add/users-add.component';
import { UsersEditComponent } from './users/users-edit/users-edit.component';
import { UsersComponent } from './users/users.component';
import { AuthGuard } from './_helpers/auth.guard';

import { Role } from './_models';
import { DailyReportComponent } from './daily-report/daily-report.component';
import { NipAllImprovedComponent } from './nip/nip-all-improved/nip-all-improved.component';
import { PartnerAllImprovedComponent } from './partners/partner-all-improved/partner-all-improved.component';
import { PartnerEditImprovedComponent } from './partners/partner-edit-improved/partner-edit-improved.component';
import { ProductsAllImprovedComponent } from './products/products-all-improved/products-all-improved.component';
import { ProductReportComponent } from './reports/product-report/product-report.component';
import { DelayReportComponent } from './reports/delay-report/delay-report.component';
import { ScrapReportComponent } from './reports/scrap-report/scrap-report.component';
import { OnlineNipComponent } from './online-nip/online-nip/online-nip.component';
import { WorkerReportComponent } from './reports/worker-report/worker-report.component';
import { WorkerDelayComponent } from './reports/worker-delay/worker-delay.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      // ? Dashboard
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.sefProizvodnje, Role.tehnolog] },
      },

      // ? OPERATIONS
      {
        path: 'operations',
        component: OperationsComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.tehnolog, Role.admin] },
      },
      {
        path: 'operations/add',
        component: OperationsAddComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.tehnolog, Role.admin] },
      },
      {
        path: 'operations/edit',
        component: OperationsEditComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.tehnolog, Role.admin] },
      },

      // ? USERS
      {
        path: 'users',
        component: UsersComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin] },
      },
      {
        path: 'users/add',
        component: UsersAddComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin] },
      },
      {
        path: 'users/edit',
        component: UsersEditComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin] },
      },

      // ? PRODUCTS
      {
        path: 'products',
        component: ProductsAllImprovedComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.tehnolog, Role.admin, Role.prodavac] },
      },
      {
        path: 'products/add',
        component: ProductsAddComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.tehnolog, Role.admin, Role.prodavac] },
      },
      {
        path: 'products/edit/:id',
        component: ProductsEditComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.tehnolog, Role.admin, Role.prodavac] },
      },
      {
        path: 'products/copy',
        component: ProductsCopyComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.tehnolog, Role.admin, Role.prodavac] },
      },

      // ? PRODUCT TYPES
      {
        path: 'product_types',
        component: ProductTypesComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin] },
      },
      {
        path: 'product_types/add',
        component: ProductTypesAddComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin] },
      },
      {
        path: 'product_types/:id/edit',
        component: ProductTypesEditComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin] },
      },

      // ? PACKAGE TYPES
      {
        path: 'package_types',
        component: PackageTypesComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.prodavac] },
      },
      {
        path: 'package_types/add',
        component: PackageTypesAddComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.prodavac] },
      },
      {
        path: 'package_types/edit',
        component: PackageTypesEditComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.prodavac] },
      },

      // ? PARTNERS
      {
        path: 'partners',
        component: PartnerAllImprovedComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.prodavac] },
      },
      {
        path: 'partners/add',
        component: PartnersAddComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.prodavac] },
      },
      {
        path: 'partners/edit/:id',
        component: PartnerEditImprovedComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.prodavac] },
      },

      // ? STATUS
      {
        path: 'status',
        component: StatusComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin] },
      },
      {
        path: 'status/add',
        component: StatusAddComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin] },
      },
      {
        path: 'status/edit',
        component: StatusEditComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin] },
      },

      // ? NIP
      // {
      //   path: 'nip',
      //   component: NipComponent,
      //   canActivate: [AuthGuard],
      //   data: {
      //     roles: [
      //       Role.admin,
      //       Role.prodavac,
      //       Role.tehnolog,
      //       Role.sefProizvodnje,
      //     ],
      //   },
      // },
      {
        path: 'nip',
        component: NipAllImprovedComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Role.admin,
            Role.prodavac,
            Role.tehnolog,
            Role.sefProizvodnje,
          ],
        },
      },
      {
        path: 'nip/add',
        component: NipAddComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Role.admin,
            Role.prodavac,
            Role.tehnolog,
            Role.sefProizvodnje,
          ],
        },
      },
      {
        path: 'nip/edit/:id',
        component: NipEditImprovedComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            Role.admin,
            Role.prodavac,
            Role.tehnolog,
            Role.sefProizvodnje,
          ],
        },
      },

      // ? MAShINES
      {
        path: 'machines',
        component: MachinsAllComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [Role.tehnolog, Role.admin],
        },
      },
      {
        path: 'machines/add',
        component: MachinsAddComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [Role.tehnolog, Role.admin],
        },
      },
      {
        path: 'machines/edit',
        component: MachinsEditComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [Role.tehnolog, Role.admin],
        },
      },
      // ? EMPLOYEE RESPONSIBILITIES
      {
        path: 'employee-responsibilities',
        component: EmployeeResponsibilitiesComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.sefProizvodnje] },
      },

      // ? NIP WORKER
      {
        path: 'nip-worker',
        component: NipWorkerAllImprovedComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.radnik] },
      },
      {
        path: 'nip-worker/edit/:id',
        component: NipWorkerEditImprovedComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.radnik] },
      },
      // ? DAILY REPORT
      {
        path: 'daily-report',
        component: DailyReportComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.sefProizvodnje, Role.tehnolog] },
      },
      // ? PERIODC REPORT
      {
        path: 'periodic-report',
        component: PeriodicReportComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.sefProizvodnje, Role.tehnolog] },
      },
      // ? PRODUCT REPORT
      {
        path: 'product-report',
        component: ProductReportComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.sefProizvodnje, Role.tehnolog] },
      },
      // ? DELAY REPORT
      {
        path: 'delay-report',
        component: DelayReportComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.sefProizvodnje, Role.tehnolog] },
      },
      // ? WORKER REPORT
      {
        path: 'worker-report',
        component: WorkerReportComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.sefProizvodnje, Role.tehnolog] },
      },
      // ? WORKER DELAY
      {
        path: 'worker-delay',
        component: WorkerDelayComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.sefProizvodnje, Role.tehnolog] },
      },
      // ? SCRAP REPORT
      {
        path: 'scrap-report',
        component: ScrapReportComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.sefProizvodnje, Role.tehnolog] },
      },

      // ?  ONLINE NIPS
      {
        path: 'online-nip',
        component: OnlineNipComponent,
        canActivate: [AuthGuard],
        data: { roles: [Role.admin, Role.sefProizvodnje] },
      },
    ],
  },
  {
    path: 'login',
    component: AuthLayoutComponent,
    children: [{ path: '', component: LoginComponent }],
  },
  { path: '**', redirectTo: '' }, // redirect to home
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
